export const SET_STRINGS = 'SET_STRINGS';
export const SET_LANGUAGE = 'SET_LANGUAGE';